import { apiRequestToken } from '../Utilidades/apiRequest';
import { BannerRequest } from '../interfaces/bannerInterfaces';
import { PopupRequest } from '../interfaces/popupInterfaces';

export const guardarPopup = async (popupRequest: PopupRequest) => {
console.log('popupRequest',popupRequest);


    return apiRequestToken({
        endpoint: 'popups/editar',
        body: popupRequest,
        method: 'POST',
    })
};

export const getPopups = async () => {
    return apiRequestToken({
        endpoint: 'popups/all',
        method: 'GET',
    })
};


export const getActivePopups = async () => {
    return apiRequestToken({
        endpoint: 'popups/allActives',
        method: 'GET',
    })
};



export const getPopup = async (id:number) => {
    return apiRequestToken({
        endpoint: 'popups/' + id,
        method: 'GET',
    })
};


export const deletePopup = async (id: number) => {
    return apiRequestToken({
        endpoint: `popups/${id}`,
        method: 'DELETE',
    })
};


export const activarDesactivarpopup = async (id: number) => {
    return apiRequestToken({
        endpoint: `popups/${id}`,
        method: 'PUT',
    })
};

